import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-form-error-message',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './form-error-message.html',
  styleUrl: './form-error-message.scss'
})
export class FormErrorMessage {
  @Input({ required: true }) form!: FormGroup;
  @Input({ required: true }) controlName!: string;

  get minimumValue(){
    return (this.field as any)?.errors?.min?.min ?? 0;
  }

  get maximumValue(){
    return (this.field as any)?.errors?.max?.max ?? 0;
  }

  get minLength(){
    return (this.field as any)?.errors?.minlength?.requiredLength ?? 0;
  }

  get field(): AbstractControl{
    return this.form?.get(this.controlName) as AbstractControl;
  }
}
